import { useCommonServiceCommonLocationsList } from '@insurance/api/queries'
import { useValidationsField } from '@insurance/hooks'
import { Text } from '@shared/components'
import { normalize } from '@shared/utils'
import { Col, Form, Input, Select } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  locationKey: string[]
  disabled?: boolean
  title?: React.ReactNode
}

export const ContractorLocation = ({ locationKey, disabled, title }: Props) => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const district = Form.useWatch([...locationKey, 'district'])
  const formInstance = Form.useFormInstance()

  const { data: districts } = useCommonServiceCommonLocationsList({
    country: 'MD'
  })

  const districtsFound = districts?.filter(({ name }) =>
    normalize(name)?.includes(normalize(district))
  )

  const districtsOptions = districts?.map(({ name }) => ({ value: name }))

  const { data: locations } = useCommonServiceCommonLocationsList(
    {
      country: 'MD',
      district: districtsFound?.[0]?.id
    },
    undefined,
    { enabled: districtsFound?.length === 1 }
  )

  const locationsOptions = locations?.map(({ name }) => ({ value: name }))

  return (
    <>
      <Col xs={24} style={{ paddingBottom: 12 }}>
        <Text size={16} strong>
          {title ?? t('contractor_domicile')}
        </Text>
      </Col>

      <Col xs={24} lg={12}>
        <Form.Item
          name={[...locationKey, 'district']}
          label={t('district')}
          rules={[required]}
        >
          <Select
            disabled={disabled}
            placeholder={t('district')}
            showSearch
            filterOption={(input, option) =>
              normalize(option?.value)?.includes(normalize(input))
            }
            options={districtsOptions}
            onSelect={() =>
              formInstance.resetFields([[...locationKey, 'location']])
            }
          />
        </Form.Item>
      </Col>
      <Col xs={24} lg={12}>
        <Form.Item
          name={[...locationKey, 'location']}
          label={t('location')}
          rules={[required]}
        >
          <Select
            disabled={disabled}
            placeholder={t('location')}
            showSearch
            filterOption={(input, option) =>
              normalize(option?.value)?.includes(normalize(input))
            }
            options={locationsOptions}
          />
        </Form.Item>
      </Col>
      <Col xs={24}>
        <Form.Item name={[...locationKey, 'street']} label={t('street')}>
          <Input disabled={disabled} placeholder={t('street')} />
        </Form.Item>
      </Col>
      <Col xs={8}>
        <Form.Item name={[...locationKey, 'number']} label={t('number')}>
          <Input disabled={disabled} placeholder={t('number')} />
        </Form.Item>
      </Col>
      <Col xs={8}>
        <Form.Item name={[...locationKey, 'block']} label={t('block')}>
          <Input disabled={disabled} placeholder={t('block')} />
        </Form.Item>
      </Col>
      <Col xs={8}>
        <Form.Item name={[...locationKey, 'apartment']} label={t('apartment')}>
          <Input disabled={disabled} placeholder={t('apartment')} />
        </Form.Item>
      </Col>
    </>
  )
}
